import { CONSTANTS_FORMS as FORMS } from '@app/presentation/mo-forms/mo-forms.constant';

export const FORM_VALIDATE_CONSTANTS = {
  VALIDATOR_MIN: {
    ['phone']: FORMS.MESSAGES.ERROR_MIN_PHONE,
    ['name']: FORMS.MESSAGES.ERROR_MIN_TEXT,
    ['firstLastName']: FORMS.MESSAGES.ERROR_MIN_TEXT,
    ['secondLastName']: FORMS.MESSAGES.ERROR_MIN_TEXT,
    ['documentNumber']: FORMS.MESSAGES.ERROR_MIN_TEXT,
  },
  VALIDATOR_MAX: {
    ['name']: FORMS.MESSAGES.ERROR_MAX_TEXT,
    ['lastName']: FORMS.MESSAGES.ERROR_MAX_TEXT,
    ['documentNumber']: FORMS.MESSAGES.ERROR_MAX_TEXT,
    ['firstLastName']: FORMS.MESSAGES.ERROR_MAX_TEXT,
    ['secondLastName']: FORMS.MESSAGES.ERROR_MAX_TEXT,
  },
};
